import styled from 'styled-components';

export const Container = styled.div`
	background-color: #ffffff !important;
	width: 100%;
	padding: ${({ theme }) => `${theme.spacing[2]}px ${theme.spacing[3]}px`};
	border-radius: 0 0 5px;
	box-shadow: 0 -2px 10px -4px #00000020;
`;
